import { render, staticRenderFns } from "./sample-text-link-list.vue?vue&type=template&id=12b099ab&"
import script from "./sample-text-link-list.vue?vue&type=script&lang=js&"
export * from "./sample-text-link-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports